import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Modal from '@ntuctech/devex-tangram/Modal';
import ModalTitle from '@ntuctech/devex-tangram/ModalTitle';
import ModalContent from '@ntuctech/devex-tangram/ModalContent';
import ModalActions from '@ntuctech/devex-tangram/ModalActions';
import Box from '@ntuctech/devex-tangram/Box';
import Typography from '@ntuctech/devex-tangram/Typography';
import ButtonContained from '@ntuctech/devex-tangram/Button/ButtonContained';

const ModalActionsSC = styled(ModalActions)``;

const SimpleModal = ({
  open,
  title,
  body,
  ctaText,
  ctaAction,
  ctaLoading,
  secondaryText,
  secondaryAction,
  secondaryLoading,
  testId,
}) => (
  <Modal data-testid={testId} open={open}>
    <ModalTitle>{title}</ModalTitle>
    <ModalContent>
      <Box mt={0.5}>
        <Typography>{body}</Typography>
      </Box>
    </ModalContent>
    <ModalActionsSC>
      {secondaryText ? (
        <ButtonContained
          color="grey"
          onClick={secondaryAction}
          data-testid={`${testId}SecondaryAction`}
          loading={secondaryLoading}
        >
          {secondaryText}
        </ButtonContained>
      ) : null}
      <ButtonContained onClick={ctaAction} data-testid={`${testId}Action`} loading={ctaLoading}>
        {ctaText}
      </ButtonContained>
    </ModalActionsSC>
  </Modal>
);

SimpleModal.defaultProps = {
  open: false,
  ctaLoading: false,
  secondaryText: undefined,
  secondaryAction: undefined,
  secondaryLoading: false,
  testId: 'SimpleModal',
};

SimpleModal.propTypes = {
  open: PropTypes.bool,
  title: PropTypes.string.isRequired,
  body: PropTypes.node.isRequired,
  ctaText: PropTypes.string.isRequired,
  ctaAction: PropTypes.func.isRequired,
  ctaLoading: PropTypes.bool,
  secondaryText: PropTypes.string,
  secondaryAction: PropTypes.func,
  secondaryLoading: PropTypes.bool,
  testId: PropTypes.string,
};

export default SimpleModal;
